module.exports = __webpack_public_path__ + "img/img10.3bd249a7.jpg";